import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'app-bwc-view-actions-bar',
  templateUrl: './bwc-view-actions-bar.component.html',
  styleUrls: ['./bwc-view-actions-bar.component.scss'],
  standalone: false,
})
export class BwcViewActionsBarComponent {
  @Input() public isLegendVisible = false
  @Input() public isWebcamLayerVisible = false

  @Output() public toggleLegend = new EventEmitter<void>()
  @Output() public toggleWebcamLayer = new EventEmitter<void>()
}
